module.exports = __webpack_public_path__ + "static/media/placeholder-dark.7dd1c9a0.svg";